import StitchUserImpl from "./StitchUserImpl";
var StitchUserFactoryImpl = (function () {
    function StitchUserFactoryImpl(auth) {
        this.auth = auth;
    }
    StitchUserFactoryImpl.prototype.makeUser = function (id, loggedInProviderType, loggedInProviderName, userProfile) {
        return new StitchUserImpl(id, loggedInProviderType, loggedInProviderName, userProfile, this.auth);
    };
    return StitchUserFactoryImpl;
}());
export default StitchUserFactoryImpl;
//# sourceMappingURL=StitchUserFactoryImpl.js.map